
const CoinStock = () => import('@/view/coinStock/CoinStock.vue')

const routes = [
  {
    path: '/coinStock',
    component: CoinStock,
  },
]
const components = {}

export default {
  routes,
  components,
}
